import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import { useHistory, Link } from 'react-router-dom';

import { accessLocalStorage, exportSelectAllQueueMembers, exportDeleteQueueMember } from '../../../services';
import MembersTable from './components/MembersTable';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';

import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faPen, faTrash} from '@fortawesome/free-solid-svg-icons';
// <FontAwesomeIcon icon="fa-thin fa-arrow-up-z-a" />

function MembersQueuesList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [sortElements, setSortElements] = useState({ key: '', direction: 'ascending'});
  const [membersQueues, setMembersQueues] = useState(() => []);
  const [membersQueuesSelected, setMembersQueuesSelected] = useState([]);
  const [disable, setDisable] = useState(true);

  const history = useHistory();

  const fetchMemberQueues = async () => {
    const membersQueuesList = await exportSelectAllQueueMembers();
    if(membersQueuesList === undefined) setLoading(true);
    const elements = membersQueuesList.map((element) => element);
    setMembersQueues(elements);
    setLoading(false);
    return true;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    const listQueuesMembers = await fetchMemberQueues();
    return listQueuesMembers;
  }, []);

  const handleChangeSelectedMembersQueues = (element) => {
    setMembersQueuesSelected(element);
    setDisable(false);
  };

  const handleClickDelete = async () => {
    const sendDeleteMembersQueues = await exportDeleteQueueMember({ id: membersQueuesSelected });
    toggleIsHidden('#alert-confirm-membersqueues-delete');
    setDisable(true);
    toggleIsHidden('#buttons');
    validateUserLogged();
    return;
  };

  const handleClickUpdate = async () => {
    setItemsSelectedToEdit(membersQueuesSelected);
    return history.push('/config/fila/membros/lista/id');
  };


  useMemo(() => {
    let sortableItems = membersQueues;
    if (sortElements !== null) {
      sortableItems.sort((a, b) => {
        if(sortElements.key === 'endpoint' && sortElements.direction === 'ascending') return a[sortElements.key] - b[sortElements.key];
        if(sortElements.key === 'endpoint' && sortElements.direction === 'descending') return b[sortElements.key] - a[sortElements.key];
        
        if (a[sortElements.key] < b[sortElements.key]) {
          return sortElements.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortElements.key] > b[sortElements.key]) {
          return sortElements.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }

    setMembersQueues(sortableItems);
    return;
  }, [sortElements]);

  const sortedCalls = (key) => {
    let newDirection = sortElements.direction;
    if (sortElements.key === '' || sortElements.key !== key) {
      newDirection = 'descending';

      setSortElements((prevState) => prevState = { key, direction: newDirection });
      return;
    }
    if (sortElements.key === key && sortElements.direction === 'ascending') {
      newDirection = 'descending';
    } else {
      newDirection = 'ascending';
    }
    setSortElements((prevState) => prevState = { key, direction: newDirection });
    return;
  };

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns is-half">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">LISTA DE MEMBROS</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <div className="columns is-fullwidth">
            <article id="alert-confirm-membersqueues-delete" name="alert-confirm-membersqueues-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
              <div className="message-header">
                <p>Atenção!</p>
                <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-confirm-membersqueues-delete') }></button>
              </div>
              <div className="message-body">
                Tem certeza que quer deletar o ramal/membro selecionado?
              </div>
              <br />
              <div className="columns">
                <div className="column is-half is-offset-one-quarter has-text-centered is-active">
                  <button className="button is-danger is-half mx-3 px-5" type="submit" onClick={ () => handleClickDelete() }>
                        <span className="icon">
                          <FontAwesomeIcon icon={ faTrash } fixedWidth />
                        </span>
                        <span>
                          Confirmar
                        </span>
                  </button>
                  <button className="button is-info is-half mx-3 px-5" type="submit" onClick={ () => {
                    toggleIsHidden('#alert-confirm-membersqueues-delete')
                    toggleIsHidden('#buttons')
                  }}>
                        <span className="icon">
                          <FontAwesomeIcon icon={ faTrash } fixedWidth />
                        </span>
                        <span>
                          Cancelar
                        </span>
                  </button>
                </div>
              </div>
            </article>
          </div>
          <div className='card column mx-2 mt-5 pt-5 my-3'>
            <div className="table-container is-flex-wrap-wrap">
              <table id="tableMembers" className="table is-hoverable is-striped is-fullwidth">
                  <thead className='has-background-link-light'>
                      <tr className='is-size-7 has-text-centered'>
                      <th scope="col">Selecione</th>
                      <th className='th-interactive is-clickable' scope="col" onClick={ () => sortedCalls('endpoint') } >
                        Ramal <FontAwesomeIcon icon={ sortElements.key === 'endpoint' && sortElements.direction === 'descending'? faArrowUp : faArrowDown } />
                      </th>
                      <th className='th-interactive is-clickable' scope="col" onClick={ () => sortedCalls('membername') } >
                        Nome Atendente <FontAwesomeIcon icon={ sortElements.key === 'membername' && sortElements.direction === 'descending'? faArrowUp : faArrowDown } />
                      </th>
                      <th className='th-interactive is-clickable' scope="col" onClick={ () => sortedCalls('queueName') }>
                        Nome da Fila <FontAwesomeIcon icon={ sortElements.key === 'queueName' && sortElements.direction === 'descending'? faArrowUp : faArrowDown } />
                      </th>
                      <th scope="col">Pausa</th>
                      <th scope="col">Prioridade</th>
                      <th scope="col">Toca em Uso</th>
                      <th scope="col">Estado</th>
                      <th scope="col">Descanso</th>
                      </tr>
                  </thead>
                  <tbody>
                  {
                    membersQueues.map((member) => <MembersTable key={ member.uniqueid } member={ member } selectMember={ handleChangeSelectedMembersQueues } />)
                  }
                  </tbody>
              </table>
            </div>
          </div>
          <div className="columns">
            <div id="buttons" className="column is-half is-offset-one-quarter has-text-centered is-active">
                <button
                  className="button is-info is-half mx-3 px-6" type="submit" onClick={ () => handleClickUpdate() } disabled={ disable }>
                      <span className="icon">
                        <FontAwesomeIcon icon={ faPen } fixedWidth />
                      </span>
                      <span>
                        Alterar
                      </span>
                </button>
                <button
                  className="button is-danger is-half mx-3 px-6"
                  type="submit"
                  onClick={ () => {
                    toggleIsHidden('#alert-confirm-membersqueues-delete')
                    toggleIsHidden('#buttons')
                    }}
                  disabled={ disable }
                >
                      <span className="icon">
                        <FontAwesomeIcon icon={ faTrash } fixedWidth />
                      </span>
                      <span>
                        Deletar
                      </span>
                </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default MembersQueuesList;
